export default __webpack_public_path__ + "static/media/ELECTIVES_REMIX.6511a312.svg";